export default function _cloneRegExp(pattern) {
                                  return new RegExp(pattern.source, (pattern.global ? 'g' : '') + (pattern.ignoreCase ? 'i' : '') + (pattern.multiline ? 'm' : '') + (pattern.sticky ? 'y' : '') + (pattern.unicode ? 'u' : ''));
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-ramda/~/ramda/es/internal/_cloneRegExp.js
// module id = 1057
// module chunks = 1